import React, { Component } from "react";
import "./Header.css";
export default class Header extends Component {
  render() {
    return (
      <div>
        <h1 className="Header">📺 Physics building Tv control 📺</h1>
      </div>
    );
  }
}
